import _ from 'lodash';
import angular from 'angular';

export const staticDataFilter = () => function (input, text, selected) {
    if (!input) {
        return input;
    }
    if (!text && selected.length === 0) {
        return input;
    }
    const newInput = [];
    for (let i = 0; i < input.length; i++) {
        if (text) {
            if (input[i].text.toLowerCase().indexOf(text.toLowerCase()) >= 0) {
                newInput.push(input[i]);
            }
        } else if (!(_.find(selected, { value: input[i].text }))) {
            newInput.push(input[i]);
        }
    }
    return newInput;
};

angular.module('TALENYA-FE').filter('staticDataFilter', staticDataFilter);
